import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();

const LEGACY_AUTH_KEYS = ['token', 'refreshToken', 'user', 'common_data'];

export const clearLegacyClientStorage = (shouldClearTranslations) => {
	LEGACY_AUTH_KEYS.forEach((key) => {
		localStorage.removeItem(key);
	});

	if (shouldClearTranslations) {
		localStorage.removeItem('translations');
	}

	queryClient.clear();
};
